import D1 from "../../components/ExcerciseTypes/Design/TypeIn";

const json = {
  1: {
    // Exercise num
    unit: "Unit 1",
    id: "WB5-V2-U1-P13-E1",
    audio: "",
    video: "",
    component: D1,
    exerciseKey: "img/FriendsPlus/Page13/E1/Key/answerKey.png",
    checkUppercase: true,
    isAllowSubmit: false,
    question: [],
    questionImage: [
      [{ url: "img/FriendsPlus/Page13/E1/1.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page13/E1/2.jpg" },
        {
          url: "img/FriendsPlus/Page13/E1/3.jpg",
          input: true,
          answer: "Are you from the U.S.A.?",
        },
        { url: "img/FriendsPlus/Page13/E1/4.jpg" },
        { url: "img/FriendsPlus/Page13/E1/5.jpg", input: true, answer: "" },
        { url: "img/FriendsPlus/Page13/E1/6.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page13/E1/7.jpg" }],
      [
        // Column4
        { url: "img/FriendsPlus/Page13/E1/8.jpg" },
        {
          url: "img/FriendsPlus/Page13/E1/9.jpg",
          input: true,
          answer: "Is your birthday in August?",
        },
        { url: "img/FriendsPlus/Page13/E1/10.jpg" },
        { url: "img/FriendsPlus/Page13/E1/11.jpg", input: true, answer: "" },
        { url: "img/FriendsPlus/Page13/E1/12.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page13/E1/13.jpg" }],
      [
        // Column6
        { url: "img/FriendsPlus/Page13/E1/14.jpg" },
        {
          url: "img/FriendsPlus/Page13/E1/15.jpg",
          input: true,
          answer: "Is Holly from Australia?",
        },
        { url: "img/FriendsPlus/Page13/E1/16.jpg" },
        {
          url: "img/FriendsPlus/Page13/E1/17.jpg",
          input: true,
          answer: "No, she isn't.",
        },
        { url: "img/FriendsPlus/Page13/E1/18.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page13/E1/19.jpg" }],
      [
        // Column8
        { url: "img/FriendsPlus/Page13/E1/20.jpg" },
        {
          url: "img/FriendsPlus/Page13/E1/21.jpg",
          input: true,
          answer: "Is your family from Viet Nam?",
        },
        { url: "img/FriendsPlus/Page13/E1/22.jpg" },
        { url: "img/FriendsPlus/Page13/E1/23.jpg", input: true, answer: "" },
        { url: "img/FriendsPlus/Page13/E1/24.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page13/E1/25.jpg" }],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 1",
    id: "WB5-V2-U1-P13-E2",
    audio: "",
    video: "",
    component: D1,
    // typeInput: "center",
    // fontSize: 40,
    // inputHeight: "100%",
    // exerciseKey: "",
    isAllowSubmit: true,
    hideBtnFooter: true,
    question: [],
    questionImage: [
      [{ url: "img/FriendsPlus/Page13/E2/1.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page13/E2/2.jpg" },
        { url: "img/FriendsPlus/Page13/E2/3.jpg", input: true, answer: "" },
        { url: "img/FriendsPlus/Page13/E2/4.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page13/E2/5.jpg" }],
      [
        // Column4
        { url: "img/FriendsPlus/Page13/E2/6.jpg" },
        { url: "img/FriendsPlus/Page13/E2/7.jpg", input: true, answer: "" },
        { url: "img/FriendsPlus/Page13/E2/8.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page13/E2/9.jpg" }],
      [
        // Column6
        { url: "img/FriendsPlus/Page13/E2/10.jpg" },
        { url: "img/FriendsPlus/Page13/E2/11.jpg", input: true, answer: "" },
        { url: "img/FriendsPlus/Page13/E2/12.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page13/E2/13.jpg" }],
      [
        // Column8
        { url: "img/FriendsPlus/Page13/E2/14.jpg" },
        { url: "img/FriendsPlus/Page13/E2/15.jpg", input: true, answer: "" },
        { url: "img/FriendsPlus/Page13/E2/16.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page13/E2/17.jpg" }],
      [{ url: "img/FriendsPlus/Page13/E2/18.jpg" }],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 1",
    id: "WB5-V2-U1-P13-E3",
    audio: "",
    video: "",
    component: D1,
    // exerciseKey: "",
    isAllowSubmit: true,
    hideBtnFooter: true,
    questionImage: [
      [{ url: "img/FriendsPlus/Page13/E3/16.jpg" }],
      [{ url: "img/FriendsPlus/Page13/E3/1.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page13/E3/2.jpg" },
        { url: "img/FriendsPlus/Page13/E3/3.jpg", input: true, answer: "" },
        { url: "img/FriendsPlus/Page13/E3/4.jpg" },
        { url: "img/FriendsPlus/Page13/E3/5.jpg", input: true, answer: "" },
        { url: "img/FriendsPlus/Page13/E3/6.jpg" },
      ],
      [
        // Column3
        { url: "img/FriendsPlus/Page13/E3/7.jpg" },
        { url: "img/FriendsPlus/Page13/E3/8.jpg", input: true, answer: "" },
        { url: "img/FriendsPlus/Page13/E3/9.jpg" },
        { url: "img/FriendsPlus/Page13/E3/10.jpg", input: true, answer: "" },
        { url: "img/FriendsPlus/Page13/E3/11.jpg" },
      ],
      [
        // Column4
        { url: "img/FriendsPlus/Page13/E3/12.jpg" },
        { url: "img/FriendsPlus/Page13/E3/13.jpg", input: true, answer: "" },
        { url: "img/FriendsPlus/Page13/E3/14.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page13/E3/15.jpg" }],
    ],
    questions: [],
  },
};

export default json;
